import { HeadsetStatus } from 'src/features/devices/devices.types';
import { Popover, Tag } from 'antd';
import { InfoCircleOutlined, ThunderboltFilled } from '@ant-design/icons';
import React from 'react';

const BatteryStatus: React.FC<{ status: HeadsetStatus }> = props => {
  const { status } = props;
  if (status?.charging)
    return (
      <Popover content={`${status.battery || 0}%`}>
        <Tag icon={<ThunderboltFilled />} color='blue' style={{ margin: 0 }}>
          Зарядка
        </Tag>
      </Popover>
    );
  return status?.battery !== null ? (
    <span>
      {status?.battery <= 15 ? (
        <Popover content={`${status.battery}%`}>
          <InfoCircleOutlined style={{ color: 'red', fontSize: 20 }} />
        </Popover>
      ) : (
        `${status.battery} %`
      )}
    </span>
  ) : (
    <span>-</span>
  );
};

export default BatteryStatus;
